import { Outlet } from "react-router-dom";
import SideBar from "../admin/share/sideBar";
import Footer from "../Mycomponent/share/footer";
import MANAGEDATA_CONFIGURE from "../confrigration/constants";
import Header from "../Mycomponent/share/header";
import { useSelector } from "react-redux";
import FallbackLoader from "../Mycomponent/share/components/FallbackLoader";
import UserHeader from "./component/Header";
import { ZustandStore } from "../store/zustand-store";
import AccountBlockDialog from "../Mycomponent/share/components/dialog/AccountBlockDialog";

const UserLayout = () => {
  const loading = useSelector((state) => state.loading);
  const { plan_loaded, customer_plan } = ZustandStore((state) => state);
  const isBlocked = customer_plan?.block === "True" || false;
  return (
    <>
      <MANAGEDATA_CONFIGURE rankTableApi={!isBlocked} />
      <UserHeader />
      <div className="body_layout">
        <SideBar type="userNavItem" />
        <div className="layout_outlet" id="home_layout">
          {!isBlocked && <Header />}
          <div className="home_layout">
            {loading || !plan_loaded ? (
              <FallbackLoader />
            ) : isBlocked ? (
              <AccountBlockDialog />
            ) : (
              <Outlet />
            )}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default UserLayout;
